// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/JobDetails.scss
// module id = ./src/styles/JobDetails.scss
// module chunks = 0